export enum CoverType {
  MAIN = 'MAIN',
  OPTIONAL = 'OPTIONAL',
  DISCOUNT = 'DISCOUNT',
}

export interface PriceOption {
  coverGroup: string
  coverType: CoverType
  premium: number
  totalPremium: number
  taxAmount: number
  active: boolean | undefined
  insurer: string
  covers?: string[]
}

export interface AdditionalPriceOption {
  coverOption: string | null
  tag: string
  premium: number
  active: boolean
}
